import * as angular from "angular";
import {IController} from "angular";
import {SortType} from "../../../../commons/types/sort.type";
import {
  RoutesPanelSortingDialogComponent
} from "../../../angular/components/routes-panel-sorting-dialog/routes-panel-sorting-dialog.component";
import {PanelService} from "../../../../commons/angular/services/panel.service";

export class RoutesSortingDropdownComponent implements IController {

  options: string[];
  sortBy?: string;
  sortType?: SortType;
  onSortChange: Function;

  constructor(private panelService: PanelService) {

  }

  $onInit() {

  }

  onToggleSort(event) {
    const panel = this.panelService.open(RoutesPanelSortingDialogComponent, event, {
      sortBy: this.sortBy,
      sortType: this.sortType,
      options: this.options
    }, {
      position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      width: 130,
      height: 122
    })

    if (panel) {
      panel.instance.onSortTypeChange.subscribe((data: {sortBy: string, sortType: SortType}) => {
        this.onSortChange({sortBy: data.sortBy, sortType: data.sortType});
      });
    }
  }

}

angular
  .module('bringoz.admin.routes')
  .component('routesSortingDropdown', {
    bindings: {
      options: '<',
      sortBy: '<?',
      sortType: '<?',
      onSortChange: '&'
    },
    template: require('./routes-sorting-dropdown.html').default,
    controller: RoutesSortingDropdownComponent
  });
